'use client';

import { createContext, useContext } from 'react';

import { DynamoTabBlok } from '../dynamo-tab/dynamo-tab.blok';

export interface TabsContextProps {
  activeTabId: string;
  setActiveTabId: (id: string) => void;
  persist?: boolean;
  tabItems: Array<DynamoTabBlok>;
  tabRefs: React.MutableRefObject<Array<HTMLElement>>;
}

export const TabsContext = createContext<TabsContextProps>({
  activeTabId: '',
  setActiveTabId: () => {},
  persist: false,
  tabItems: [],
  tabRefs: { current: [] },
});

export const useTabsContext = () => useContext(TabsContext);
